// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-s-alert/dist/s-alert-css-effects/slide.css
// module id = 2811
// module chunks = 0